import { Trophy } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface ScorePanelProps {
  score: number;
  level: number;
  lines: number;
  highScore: number;
  highScoreDate?: string | null;
}

export function ScorePanel({ score, level, lines, highScore, highScoreDate }: ScorePanelProps) {
  const { t, language } = useLanguage();

  const formattedDate = highScoreDate
    ? new Date(highScoreDate).toLocaleDateString(
        language === 'fi' ? 'fi-FI' : language === 'sv' ? 'sv-SE' : 'en-US',
        { day: 'numeric', month: 'numeric', year: 'numeric' }
      )
    : null;

  return (
    <div className="glass-card p-4 space-y-4">
      <div>
        <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">{t.score.score}</p>
        <p className="text-2xl font-bold gradient-text">{score.toLocaleString()}</p>
      </div>
      <div className="flex gap-4">
        <div>
          <p className="text-xs text-muted-foreground uppercase tracking-wider">{t.score.level}</p>
          <p className="text-lg font-bold text-foreground">{level}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground uppercase tracking-wider">{t.score.lines}</p>
          <p className="text-lg font-bold text-foreground">{lines}</p>
        </div>
      </div>
      <div className="border-t border-border pt-3">
        <div className="flex items-center gap-2">
          <Trophy className="w-4 h-4 text-accent" />
          <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">{t.score.record}</p>
        </div>
        <p className="text-xl font-bold text-accent">{highScore.toLocaleString()}</p>
        {formattedDate && (
          <p className="text-[10px] text-muted-foreground mt-0.5">{t.score.recordDate} {formattedDate}</p>
        )}
      </div>
    </div>
  );
}
